var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56248 0.418489L0.376227 7.77609C0.257013 7.89694 0.162391 8.04071 0.0978185 8.19912C0.0332457 8.35753 6.43679e-08 8.52743 5.68668e-08 8.69904C4.93656e-08 8.87065 0.0332457 9.04055 0.0978185 9.19896C0.162391 9.35737 0.257013 9.50114 0.376227 9.62199C0.614534 9.8641 0.9369 10 1.27292 10C1.60894 10 1.9313 9.8641 2.16961 9.62199L8.52913 3.18734L14.825 9.62199C15.0634 9.8641 15.3857 10 15.7217 10C16.0578 10 16.3801 9.8641 16.6184 9.62199C16.7386 9.5016 16.8342 9.35803 16.8997 9.1996C16.9652 9.04117 16.9993 8.87103 17 8.69904C16.9993 8.52705 16.9652 8.35691 16.8997 8.19848C16.8342 8.04005 16.7386 7.89648 16.6184 7.77609L9.43218 0.418489C9.31307 0.286539 9.16852 0.181235 9.00763 0.109209C8.84673 0.0371832 8.67298 -5.74566e-07 8.49733 -5.82244e-07C8.32168 -5.89922e-07 8.14793 0.0371832 7.98703 0.109208C7.82614 0.181235 7.68158 0.286539 7.56248 0.418489Z",
    fill: "#01AB6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropup);
export default __webpack_public_path__ + "static/media/dropup.81a7d7509050908fc8c78c20e5576531.svg";
export { ForwardRef as ReactComponent };